// extracted by mini-css-extract-plugin
module.exports = {"appBar":"appbar_appBar__3V73t","toolbar":"appbar_toolbar__1yWn9","avatar":"appbar_avatar__hfdhm","popover":"appbar_popover__KR7r1"};